export enum FlowRebacPermission {
  AgentView = 'flowbuilder.agent.view',
  AgentModify = 'flowbuilder.agent.modify',
  AgentPublish = 'flowbuilder.agent.publish',
  AgentGrant = 'flowbuilder.agent.grant',
}

export enum PermissionEntityType {
  Organization = 'Organization',
  Agent = 'Agent',
}

interface BasePermissionGroupRow {
  roleId: string;
  roleName: string;
  rolePermissions: FlowRebacPermission[];
  userIds: string[];
}

export interface OrganizationPermissionGroupRow extends BasePermissionGroupRow {
  entityType: PermissionEntityType.Organization;
  entityId: string;
  organizationId: string;
}

export interface AgentPermissionGroupRow extends BasePermissionGroupRow {
  entityType: PermissionEntityType.Agent;
  entityId: string;
  organizationId: string | null;
  agentName: string;
}

export type PermissionGroupRow = OrganizationPermissionGroupRow | AgentPermissionGroupRow;

export interface PermissionRole {
  id: string;
  created: string;
  updated: string;
  name: string;
  permissions: FlowRebacPermission[];
}

export type UserDirectPermissions = Partial<
  Record<PermissionEntityType, Record<string, FlowRebacPermission[]>>
>;
